import { formatDate } from 'date-fns';
export function addTimestampToFileName() {
    return formatDate(new Date(), "yyyy-MM-dd'T'HH-mm");
}
